import React, { Component } from 'react';

export default class OverrideWrapper extends Component {
	render() {
		const { prop, overrides } = this.props;
		const displayDot = overrides && overrides.find(o => o.field === prop);

		const classes = [];
		if (displayDot) classes.push('wrapper-dot-input');

		return <div className={classes.join(' ')}>{this.props.children}</div>;
	}
}
